import { Spinner } from 'flowbite-react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { BUTTON_CLASSES } from '@src/constants';

import { IButton } from './interfaces';

export const Button = ({
  children,
  className,
  show = true,
  isLoading = false,
  ...rest
}: IButton) => {
  return show ? (
    <button
      {...rest}
      disabled={rest.disabled || isLoading}
      className={twMerge(BUTTON_CLASSES, className)}
    >
      {isLoading ? <Spinner /> : children}
    </button>
  ) : null;
};
